var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicNodeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1324 7.75186C10.6358 7.96594 9.48529 9.25303 9.48529 10.8088C9.48529 11.1974 9.55706 11.5692 9.68807 11.9118H6.39706C6.1534 11.9118 5.95588 11.7142 5.95588 11.4706V6.17647C5.95588 5.93282 6.1534 5.73529 6.39706 5.73529H11.6912C11.9348 5.73529 12.1324 5.93282 12.1324 6.17647V7.75186ZM8.76457 5.07353H6.39706C5.78792 5.07353 5.29412 5.56733 5.29412 6.17647V10.5882H0.441174C0.106295 10.5882 -0.10649 10.2298 0.0538673 9.9358L5.34798 0.229918C5.5152 -0.0766394 5.95539 -0.0766394 6.1226 0.229918L8.76457 5.07353ZM12.5735 13.2353C11.2334 13.2353 10.1471 12.1489 10.1471 10.8088C10.1471 9.46872 11.2334 8.38235 12.5735 8.38235C13.9136 8.38235 15 9.46872 15 10.8088C15 12.1489 13.9136 13.2353 12.5735 13.2353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicNodeLabel);
export default __webpack_public_path__ + "static/media/graphic-node-label.c233fd9f6ba4c857362fbb1187a86900.svg";
export { ForwardRef as ReactComponent };